import React from "react";

import {IAmplitudeItemListContext} from "../../tracking/amplitude/get_amplitude_view_item_event_properties";
import {ILatestQuery} from "../../utils/latest_query";
import {IOfferBox, OfferBox} from "../components/offer_box/OfferBox";
import {useOfferDetailsActions} from "../hooks/use_offer_details_actions";
import {IModalPropertyListOffer} from "../list/components/OfferListPropertiesModal";
import {IOfferBoxOffer} from "../types/IOfferBoxOffer";
import {IOfferModalOffer} from "../types/OfferModalOffer";

interface IProps {
    dataTestId?: string;
    offer: IOfferBoxWithPropertiesModalOffer;
    unlinkVendor?: boolean;
    shouldLinkToOffer?: boolean;
    showUspVariant?: boolean;
    onClick?: () => void;
    index: number;
    titleTag?: React.ElementType;
    latestQuery?: ILatestQuery & Record<string, string | string[] | null>;
    trackingMeta: IOfferBox["trackingMeta"];
    amplitudeItemListContext?: IAmplitudeItemListContext | null;
    displayAddress?: IOfferBox["displayAddress"];
}

export type IOfferBoxWithPropertiesModalOffer = IOfferBoxOffer & IModalPropertyListOffer;

export function OfferBoxWithOfferDetailsAction(props: IProps) {
    const {
        unlinkVendor,
        trackingMeta,
        index,
        offer,
        dataTestId,
        latestQuery,
        onClick,
        shouldLinkToOffer,
        showUspVariant,
        displayAddress,
        titleTag,
        amplitudeItemListContext
    } = props;

    const {showOfferDetailsGeneralHandler} = useOfferDetailsActions();

    const handleShowOfferDetailsBtnClick = (offer: IOfferModalOffer) => {
        showOfferDetailsGeneralHandler({
            offer,
            latestQuery,
            gtmSource: trackingMeta.source,
            amplitudeItemListContext
        });
    };

    return (
        <OfferBox
            offer={offer}
            onShowOfferDetailsBtnClick={handleShowOfferDetailsBtnClick}
            offerDetailsBtnText={offer.configuration.pre_sale ? "Zobacz inwestycję" : undefined}
            unlinkVendor={unlinkVendor}
            shouldLinkToOffer={shouldLinkToOffer}
            showUspVariant={showUspVariant}
            displayAddress={displayAddress}
            onClick={onClick}
            index={index}
            titleTag={titleTag}
            trackingMeta={trackingMeta}
            amplitudeItemListContext={amplitudeItemListContext}
            latestQuery={latestQuery}
            dataTestId={dataTestId}
        />
    );
}
import React from "react";

import {IAmplitudeItemListContext} from "../../tracking/amplitude/get_amplitude_view_item_event_properties";
import {ILatestQuery} from "../../utils/latest_query";
import {IOfferBox, OfferBox} from "../components/offer_box/OfferBox";
import {useOfferDetailsActions} from "../hooks/use_offer_details_actions";
import {IModalPropertyListOffer} from "../list/components/OfferListPropertiesModal";
import {IOfferBoxOffer} from "../types/IOfferBoxOffer";
import {IOfferModalOffer} from "../types/OfferModalOffer";

interface IProps {
    dataTestId?: string;
    offer: IOfferBoxWithPropertiesModalOffer;
    unlinkVendor?: boolean;
    shouldLinkToOffer?: boolean;
    showUspVariant?: boolean;
    onClick?: () => void;
    index: number;
    titleTag?: React.ElementType;
    latestQuery?: ILatestQuery & Record<string, string | string[] | null>;
    trackingMeta: IOfferBox["trackingMeta"];
    amplitudeItemListContext?: IAmplitudeItemListContext | null;
    displayAddress?: IOfferBox["displayAddress"];
}

export type IOfferBoxWithPropertiesModalOffer = IOfferBoxOffer & IModalPropertyListOffer;

export function OfferBoxWithOfferDetailsAction(props: IProps) {
    const {
        unlinkVendor,
        trackingMeta,
        index,
        offer,
        dataTestId,
        latestQuery,
        onClick,
        shouldLinkToOffer,
        showUspVariant,
        displayAddress,
        titleTag,
        amplitudeItemListContext
    } = props;

    const {showOfferDetailsGeneralHandler} = useOfferDetailsActions();

    const handleShowOfferDetailsBtnClick = (offer: IOfferModalOffer) => {
        showOfferDetailsGeneralHandler({
            offer,
            latestQuery,
            gtmSource: trackingMeta.source,
            amplitudeItemListContext
        });
    };

    return (
        <OfferBox
            offer={offer}
            onShowOfferDetailsBtnClick={handleShowOfferDetailsBtnClick}
            offerDetailsBtnText={offer.configuration.pre_sale ? "Zobacz inwestycję" : undefined}
            unlinkVendor={unlinkVendor}
            shouldLinkToOffer={shouldLinkToOffer}
            showUspVariant={showUspVariant}
            displayAddress={displayAddress}
            onClick={onClick}
            index={index}
            titleTag={titleTag}
            trackingMeta={trackingMeta}
            amplitudeItemListContext={amplitudeItemListContext}
            latestQuery={latestQuery}
            dataTestId={dataTestId}
        />
    );
}
